// extracted by mini-css-extract-plugin
module.exports = {"title":"underlinedtitle-module--title--3qN9Y","bold":"underlinedtitle-module--bold--hjI8J"};